// extracted by mini-css-extract-plugin
module.exports = {"drawer":"Index_drawer__1ZyFf","bottom":"Index_bottom__1E-Dj"};